import { render, staticRenderFns } from "./DimensionItem.vue?vue&type=template&id=a3bbc7c4&scoped=true&"
import script from "./DimensionItem.vue?vue&type=script&lang=js&"
export * from "./DimensionItem.vue?vue&type=script&lang=js&"
import style0 from "./DimensionItem.vue?vue&type=style&index=0&id=a3bbc7c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bbc7c4",
  null
  
)

export default component.exports